export enum CapBlockTable {
    entity = 1,
    loanEscrow = 2,
    userCryptoAddress = 3,
    investment = 4,
    loan = 5,
    loanRequest = 6,
    monthlyLoanStatement = 7
}